export enum AuthRoleEnum {
  SERVICERCONFIGURATION = 'servicerconfiguration',
  READONLY = 'servicerconfiguration_readonly',
  COMM_ONLY = 'servicerconfiguration_comm_only',
  CORRECT_USER = 'portaluser',
  ADMIN = 'admin',
  SCHOOL = 'school'
}
